export const SIGNALR_HUB = 'https://signalR.hollywoodbets.co.mz/inplayhub';
export const BETAPI = 'https://betapi.hollywoodbets.co.mz';
export const AVAILABLE_SPORTS_MOZ = {
    "Football": "Football",
    "Tennis": "Tennis"
}